import { useCallback, useLayoutEffect, useRef, useState } from "react";
import background from "./libs/background.png";
import knife from "./libs/knife.png";
import statue from "./libs/statue.png";
import "./Helper_3rd.css";

function Helper_3rd() {
  const [isLoading, setIsLoading] = useState(true);
  const [ranNum, setRanNum] = useState(0);
  const [ranNum2, setRanNum2] = useState(0);
  const [image, setImage] = useState(0);
  const [timer, setTimer] = useState(0);
  const [message, setMessage] = useState("결과는?");
  const [option, setOption] = useState(0);
  const id = useRef(null);

  const clear = () => {
    window.clearInterval(id.current);
  };

  const setRandom = useCallback(() => {
    setMessage("결과는?");
    if (timer === 5) setTimer(1);
    setTimer(5);
    let num = Math.floor(Math.random() * 13);
    while (
      num !== 1 &&
      num !== 3 &&
      num !== 5 &&
      num !== 6 &&
      num !== 7 &&
      num !== 9 &&
      num !== 11 &&
      num !== 12
    ) {
      num = Math.floor(Math.random() * 13);
    }
    setRanNum2(Math.floor(Math.random() * 10));
    setRanNum(num);
  }, [timer]);

  useLayoutEffect(() => {
    if (option !== 0)
      id.current = window.setInterval(() => {
        setTimer((time) => time - 1);
      }, 1000);
    return () => clear();
  }, [timer, option]);

  useLayoutEffect(() => {
    if (isLoading) {
      setRandom();
      setIsLoading(false);
    }
    if (timer === 0) {
      setRandom();
    }
    if (option === 1) setImage(knife);
    else if (option === 2) setImage(statue);
  }, [isLoading, setRandom, timer, option]);

  const GetDiv = () => {
    let obj = [];
    if (option === 1) {
      if (ranNum === 12 || ranNum === 6) obj = [div3, div6, div9, div12];
      else if (ranNum === 1 || ranNum === 7) obj = [div1, div5, div7, div12];
      else if (ranNum === 3) obj = [div3, div5, div7, div12];
      else if (ranNum === 5) {
        if (ranNum2 <= 4) obj = [div3, div5, div7, div9];
        else obj = [div5, div7, div9, div12];
      } else if (ranNum === 9) obj = [div1, div3, div7, div9];
      else if (ranNum === 11) obj = [div1, div5, div7, div11];
    }
    if (option === 2) {
      if (ranNum === 1 || ranNum === 3) obj = [div1, div3, div6, div9, div11];
      else if (ranNum === 5) {
        if (ranNum2 <= 7) obj = [div1, div3, div5, div6, div11];
        else obj = [div1, div5, div6, div11, div12];
      } else if (ranNum === 6) obj = [div1, div5, div6, div7, div11];
      else if (ranNum === 7) obj = [div3, div6, div7, div9, div11];
      else if (ranNum === 9) obj = [div12, div5, div6, div9, div11];
      else if (ranNum === 11) obj = [div12, div3, div6, div9, div11];
      else if (ranNum === 12) obj = [div12, div1, div5, div7, div11];
    }

    return obj;
  };

  const getAnswer = (e) => {
    clear();
    const name = e.target.className;
    if (option === 1) {
      if (ranNum === 12 || ranNum === 6) {
        if (ranNum2 <= 4 && name === "12시") setMessage("성공!");
        else if (ranNum2 >= 5 && name === "6시") setMessage("성공!");
        else {
          if (ranNum2 <= 4) setMessage(`실패! 정답: 12시`);
          else setMessage(`실패! 정답: 6시`);
        }
      } else if (ranNum === 1 || ranNum === 7) {
        if (ranNum2 <= 4 && name === "1시") setMessage("성공!");
        else if (ranNum2 >= 5 && name === "7시") setMessage("성공!");
        else {
          if (ranNum2 <= 4) setMessage(`실패! 정답: 1시`);
          else setMessage(`실패! 정답: 7시`);
        }
      } else if (ranNum === 3 && name === "3시") setMessage("성공!");
      else if (ranNum === 5 && name === "5시") setMessage("성공!");
      else if (ranNum === 9 && name === "9시") setMessage("성공!");
      else if (ranNum === 11 && name === "11시") setMessage("성공!");
      else setMessage(`실패! 정답: ${ranNum}시`);
    } else if (option === 2) {
      if (ranNum === 5 && name === "5시") setMessage("성공!");
      else if (ranNum === 6 && name === "6시") setMessage("성공!");
      else if (ranNum === 7 && name === "7시") setMessage("성공!");
      else if (ranNum === 9 && name === "9시") setMessage("성공!");
      else if (ranNum === 11 && name === "11시") setMessage("성공!");
      else if (ranNum === 12 && name === "12시") setMessage("성공!");
      else if (ranNum === 1 || ranNum === 3) {
        if (ranNum2 <= 4 && name === "1시") setMessage("성공!");
        else if (ranNum2 >= 5 && name === "3시") setMessage("성공!");
        else {
          if (ranNum2 <= 4) setMessage(`실패! 정답: 1시`);
          else setMessage(`실패! 정답: 3시`);
        }
      } else setMessage(`실패! 정답: ${ranNum}시`);
    }
    setTimeout(() => {
      setRandom();
    }, 2000);
  };

  const div12 = (
    <div className="Div12" key="12" onClick={getAnswer}>
      <img className="12시" width="100%" height="100%" src={image} alt="12시" />
    </div>
  );
  const div11 = (
    <div className="Div11" key="11" onClick={getAnswer}>
      <img className="11시" width="100%" height="100%" src={image} alt="11시" />
    </div>
  );
  const div1 = (
    <div className="Div1" key="1" onClick={getAnswer}>
      <img className="1시" width="100%" height="100%" src={image} alt="1시" />
    </div>
  );
  const div3 = (
    <div className="Div3" key="3" onClick={getAnswer}>
      <img className="3시" width="100%" height="100%" src={image} alt="3시" />
    </div>
  );
  const div5 = (
    <div className="Div5" key="5" onClick={getAnswer}>
      <img className="5시" width="100%" height="100%" src={image} alt="5시" />
    </div>
  );
  const div7 = (
    <div className="Div7" key="7" onClick={getAnswer}>
      <img className="7시" width="100%" height="100%" src={image} alt="7시" />
    </div>
  );
  const div9 = (
    <div className="Div9" key="9" onClick={getAnswer}>
      <img className="9시" width="100%" height="100%" src={image} alt="9시" />
    </div>
  );
  const div6 = (
    <div className="Div6" key="6" onClick={getAnswer}>
      <img className="6시" width="100%" height="100%" src={image} alt="6시" />
    </div>
  );
  return (
    <div className="Main">
      <img className="Background" src={background} alt="back" />
      {option === 0 && (
        <div className="Option">
          <div
            className="Option_Child"
            onClick={() => {
              setOption(1);
            }}
          >
            칼
          </div>
          <div
            className="Option_Child"
            onClick={() => {
              setOption(2);
            }}
          >
            분신
          </div>
        </div>
      )}
      {option !== 0 && (
        <>
          <div className="Progress">
            <span className="Result">{message}</span>
            <progress className="ProgressBar" value={timer} max="5"></progress>
            <span className="leftTime">남은 시간: {timer}초</span>
          </div>

          <GetDiv />
        </>
      )}
    </div>
  );
}

export default Helper_3rd;
